import { DataFaker } from '@cicero/data/utils'

export const FooFunc: IFormulaFunc = {
  key: 'FOO',
  description: 'Always returns FOO with params joined if they exist',
  perform: (...args: string[]) => `FOO${ args && args.length ? ` was passed ${args.length} params (${args.join(' | ')})` : '' }`,
}

export const BarFunc: IFormulaFunc = {
  key: 'BAR',
  description: 'Returns a random drink from dependent on an input string',
  perform: (seedString: string = 'hello') => DataFaker.gen(DataFaker.DRINKS, DataFaker.genSeed(seedString)),
}

export const AddFunc: IFormulaFunc = {
  key: 'ADD',
  description: 'Adds an array of numbers',
  perform: (...args: string[]) => `${args.reduce((acc, a) => acc + parseInt(a), 0)}`,
}

export const defaultFuncList = [
  FooFunc,
  BarFunc,
  AddFunc,
]

export interface IFormulaFunc {
  key: string
  description: string
  perform: (...args: any[]) => string
}

export interface IInstruction {
  type: 'func'
  name: string
  params: any[]
}
